import { ChangeEventHandler, FormEvent, useRef, useState } from 'react'
import textServices from 'services/text-services'
import { SubTitleAge, TitleAge } from 'components/legal-age/components/style/text'
import { ButtonInit } from '../../theme/theme'
import DateInput from './date-input'

export interface DateInputProps {
  type: 'day' | 'month' | 'year'
  defaultValue?: number
  placeholder?: string
}

export interface FormState {
  day: string
  month: string
  year: string
}

const textSharedProps = {
  className: 'text-center saira mt-4',
  style: { fontSize: 10 }
}

const BirthdayInput = ({ setAgeLocal }: { setAgeLocal: (day?: string, month?: string, year?: string) => void }) => {

  const [state, setFormState] = useState<Partial<FormState>>({})

  const yearRef = useRef<HTMLInputElement>(null)
  const monthRef = useRef<HTMLInputElement>(null)

  const onSubmitHandler = (event: FormEvent) => {
    event.preventDefault()

    const { day = '00', month = '00', year = '00' } = state
    setAgeLocal(day, month, year)
  }

  const handleOnChange: ChangeEventHandler<HTMLInputElement> = ({ target: { value, name } }) => {
    setFormState((formState: any) => ({ ...formState, [name]: value }))

    const refs: Record<string, HTMLInputElement | null> = {
      day: monthRef.current,
      month: yearRef.current
    }

    if (value.length === 2) {
      refs[name as string]?.focus()
    }
  }

  return (
    <form className="flex-1 mx-7 flex flex-col mb-7" onSubmit={onSubmitHandler}>
      <div className="flex-1 flex flex-col justify-center">
        <div className="uppercase">
          <TitleAge className="font-bold text-5xl uppercase text-center my-6">{textServices.findByText('agegate/title', '¡Bienvenid@!')}</TitleAge>
          <div className='w-full'>
            {textServices.findByText('agegate/description', <SubTitleAge className="text-regular text-center saira font-medium mb-4 sm:mb-0">Ingresa tu fecha de nacimiento, <br /> queremos validar tu mayoría<br /> de edad.</SubTitleAge>)}
          </div>
        </div>
        <div className="flex w-full justify-between flex-col sm:h-auto">
          <div className="w-full sm:w-48 grid grid-cols-3 mx-auto my-4">
            <DateInput type="day" max="31" min="1" placeholder="00" onChange={handleOnChange} />
            <DateInput ref={monthRef} type="month" max="12" min="1" placeholder="00" onChange={handleOnChange} />
            <DateInput ref={yearRef} type="year" max="99" min="00" placeholder="00" onChange={handleOnChange} />
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center">
        <ButtonInit
          type="submit"
          className="din p-4 h-16 w-full mx-auto rounded-none din font-bold"
          onClick={() => {
            gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: 'BIRTHDAY - Mayor de 18', value: '10' })
          }}
        >
          {textServices.findByText('agegate/button', 'INGRESAR')}
        </ButtonInit>
        <p {...textSharedProps}>
          {textServices.findByText('agegate/politics1', <>AL ENVIAR ESTE FORMULARIO, ACEPTAS LA POLÍTICA DE PRIVACIDAD, <a href={`${process.env.PUBLIC_URL}/terms-and-conditions`} rel="noreferrer" target="_blank" className="underline">TÉRMINOS Y CONDICIONES Y USO DE COOKIES</a > DE ESTE SITIO WEB.</>)}
        </p>
        <p {...textSharedProps}>
          {textServices.findByText('agegate/politics2', 'ESTE SITIO WEB UTILIZA COOKIES. PARA OBTENER MÁS INFORMACIÓN, LEE NUESTRA POLÍTICA DE PRIVACIDAD Y USO DE COOKIES.')}
        </p>
      </div>
    </form >
  )
}

export default BirthdayInput
